jQuery(document).ready(function ($) {


    var $header = $('.header-v2');

    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 300) {
            $header.addClass('scrolled');
        } else {
            $header.removeClass('scrolled');
        }
    });

    $(document).on('click', '.search-icon', function (e) {
        e.preventDefault();
        $('.search-popup').fadeIn('slow');
        $('.header__search details').prop('open', true);
    });
    $(document).on('click', '.popup-close', function (e) {
        e.preventDefault();
        $('.search-popup').fadeOut('slow');
        $('.header__search details').prop('open', false);
    });

    $(document).on('click', '.cart-icon', function (e) {
        e.preventDefault();

        const drawer = document.querySelector('cart-drawer');

        drawer.classList.add('active');
        drawer.setAttribute('open', true);
    });

    $(document).on('click', '.menu-icon', function (e) {
        e.preventDefault();
        $('.mobile-menu').slideDown();
    })
    $(document).on('click', '.mobile-menu .popup-close', function (e) {
        e.preventDefault();
        $('.mobile-menu').slideUp();
    })

    $(document).on('click', '.faq-item', function (e) {
        let faq_content = $(this).find('.faq-answer');
        if ($(this).hasClass('faq-active')) {
            $(faq_content).slideUp();
            $(this).removeClass('faq-active');
        } else {
            $(faq_content).slideDown();
            $(this).addClass('faq-active');
        }
    })

    $(document).on('submit', '.mp-product-form', function (e) {
        e.preventDefault();

        let form = this;
        let formData = new FormData(form);

        let $button = $(this).find('.mp-add-to-cart');

        // 🚫 anti-spam lock
        if ($button.data('loading')) return;
        $button.data('loading', true);

        let originalText = $button.text();

        // UI state
        $button
            .prop('disabled', true)
            .text('Adding...');

        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
            .then(() => fetch('/cart?section_id=cart-drawer'))
            .then(res => res.text())
            .then((html) => {

                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const newCart = doc.querySelector('#CartDrawer');
                const drawer = document.querySelector('cart-drawer');

                if (!drawer || !newCart) return;

                drawer.classList.remove('is-empty');

                const current = drawer.querySelector('#CartDrawer');
                if (current) {
                    current.innerHTML = newCart.innerHTML;
                }

                const isEmpty = newCart.classList.contains('is-empty');
                const inner = drawer.querySelector('.drawer__inner');

                if (inner) {
                    inner.classList.toggle('is-empty', isEmpty);
                }

                drawer.open();
            })
            .catch(console.error)
            .finally(() => {
                $button
                    .prop('disabled', false)
                    .text(originalText)
                    .data('loading', false);
            });
    });


    $(document).on('click', '.mp-buy-now', function (e) {
        e.preventDefault();

        let $button = $(this);

        // 🚫 anti-spam lock
        if ($button.data('loading')) return;
        $button.data('loading', true);

        let originalText = $button.text();

        let form = document.querySelector('.mp-product-form');
        let formData = new FormData(form);

        $button
            .prop('disabled', true)
            .text('Loading...');

        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
            .then(() => {
                window.location.href = '/checkout';
            })
            .catch((err) => {
                console.error(err);

                // only restores if error (since success redirects away)
                $button
                    .prop('disabled', false)
                    .text(originalText)
                    .data('loading', false);
            });
    });

    $(document).on('click', '.mp-qty-plus', function () {
        let input = $('.mp-qty-input');
        let value = parseInt(input.val() || 1);

        input.val(value + 1).trigger('change');
    });

    $(document).on('click', '.mp-qty-minus', function () {
        let input = $('.mp-qty-input');
        let value = parseInt(input.val() || 1);

        if (value > 1) {
            input.val(value - 1).trigger('change');
        }
    });


    if ($(window).width() < 1025 ) {
        $(document).on('click', '.has-dropdown', function (e) {
            let submenu = $(this).find('.menu-dropdown');
           if ($(this).hasClass('has-dropdown-open')) {
               $(this).removeClass('has-dropdown-open');
               $(submenu).slideUp();
           } else {
               $('.has-dropdown').removeClass('has-dropdown-open');
               $('.menu-dropdown').slideUp();
               $(this).addClass('has-dropdown-open');
               $(submenu).slideDown();
           }
        });
    }

});